import supabase from "@/lib/supabase";

export async function verifyAdminPassword(password: string): Promise<boolean> {
  const trimmed = password.trim();
  if (!trimmed) return false;

  const { data, error } = await supabase.rpc("verify_admin_password", {
    input_password: trimmed,
  });

  if (error) {
    console.error("Admin password verification failed:", error.message);
    return false;
  }

  return data === true;
}
